import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const WAKE_UP_2024_CAMPAIGN_END_DATE = d(2024, 10, 16, 0);

export const WAKE_UP_PART2_2024_CAMPAIGN_END_DATE = d(2024, 11, 14, 0);
